import React from 'react'
import Slider from 'react-slick'
import { makeStyles } from '@material-ui/core'
import UserAvatar from '../shared/UserAvatar'
import gallerySVG from '../../assets/icons/gallery.svg'
import StyledSVG from '../shared/StyledSVG'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
  root: {
    '& .slick-slide': {
      padding: '10px 0px'
    },
    '& .slick-list': {
      width: '100%',
      margin: '-10px 0px'
    }
  },
  title: {
    color: '#386093',
    fontSize: 28,
    fontWeight: 600
  },
  message: {
    cursor: 'pointer',
    minHeight: 185,
    padding: '16px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: 16
  },
  rps_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  message_overview: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .message-date': {
      color: '#9B9B9B',
      fontSize: 14,
      fontWeight: 500
    }
  },
  message_file_wrapper: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ADB8CC26',
    borderRadius: 16
  },
  message_content: {
    fontSize: 14,
    fontWeight: 400,
    color: '#9B9B9B'
  },
  room_participants: {
    '& p': {
      margin: 0,
      fontSize: 16,
      fontWeight: 500
    }
  }
}))

const LastMessagesSlider = ({
  getMessagesWithoutRoomRSPA,
  history,
  currentOccupation
}) => {
  const classes = useStyles()
  const [lastMessages, setLastMessages] = React.useState({ items: [] })
  const [isDragging, setIsDragging] = React.useState(false)
  const defaultParams = { 'page[size]': 20, 'q[message_type_not_eq]': 1 }

  React.useEffect(async () => {
    getMessagesWithoutRoomRSPA({
      params: {
        ...defaultParams
      },
      currentOccupation
    }).then(res => {
      setLastMessages(prev => ({ items: res }))
    })
  }, [])

  const handleClickItem = (e, roomId) => {
    if (isDragging) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    history.push(`/rooms/${roomId}`)
  }

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Últimas mensagens</h1>
      <Slider
        dots
        infinite={false}
        slidesToShow={4}
        slidesToScroll={3}
        vertical
        verticalSwiping
        beforeChange={() => setIsDragging(true)}
        afterChange={() => setIsDragging(false)}
      >
        {lastMessages.items.map(message => {
          const target =
            message.room.room_type === 'group'
              ? message.room.name
              : message.room.participants.find(
                  rp => rp.user.fractal_id !== message.user_id
                ).user.name
          return (
            <div
              onClick={event => handleClickItem(event, message.room_id)}
              key={message.id}
              className={classes.message}
            >
              <div className={classes.message_overview}>
                <div className={classes.rps_wrapper}>
                  <UserAvatar
                    avatarStyle={{ width: 56, height: 56 }}
                    // avatarUrl={message?.user?.avatar_url}
                    userName={message?.user_name}
                    withoutUserName
                  />
                  <div className={classes.room_participants}>
                    <p className='origin'>
                      Enviado por <b>{message?.user_name}</b>
                    </p>
                    <p className='target'>
                      para <b>{target}</b>
                    </p>
                  </div>
                </div>
                <p className='message-date'>
                  {moment(message.created_at).format('DD/MM/YYYY')}
                </p>
              </div>

              {message.content && (
                <p className={classes.message_content}>{message.content}</p>
              )}
              {message.files_urls.length > 0 && (
                <div className={classes.message_file_wrapper}>
                  <StyledSVG src={gallerySVG} height={35} width={35} />
                </div>
              )}
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default LastMessagesSlider
